import React from 'react';
import { EventCategoryPage } from '../../components/Events/EventCategoryPage';
import { EVENT_CATEGORIES } from '../../data/eventCategoryData';
const MidnightReleases = () => <EventCategoryPage config={EVENT_CATEGORIES['midnight-releases']} data-id="element-9875" data-mp="2lp35hcnklrk4" />;
export default MidnightReleases;